import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    background: "#ffffff",
    height: "100%",
    minHeight: "100%",
    justifyContent: "space-between",
    flexDirection: "column"
  },

  bodyHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "21px"
  },

  button: {
    color: "#E5E5E5"
  },

  menuIcon: {
    position: "relative"
  },

  notificationsIcon: {
    position: "relative"
  },

  logoBranco: {
    position: "relative"
  },

  lojinhaContent: {
    position: "relative"
  },

  closeBtn: {
    height: "20px",
    width: "20px",
    color: "#fff",
    padding: "5px"
  },

  ContainerMaintence: {
    marginTop: "40px",
    "& h2": {
      textAlign: "center",
      fontSize: "1rem",
    },
    "& p": {
      fontSize: "0.875rem",
    },
    "& div": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    "& label": {
      color: "#555555",
      fontSize: "1rem",
    }
  }
}))
